var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-type"},[_c('p',[_vm._v(_vm._s(_vm.filter.name))]),_c('div',{staticClass:"img",class:_vm.filter.name,style:({ backgroundImage: 'url(' + _vm.image + ')' }),on:{"click":_vm.selectFilter}})])}
var staticRenderFns = []

export { render, staticRenderFns }